import { render } from "./Pagination.vue?vue&type=template&id=f44ab6ca"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Common/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f44ab6ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f44ab6ca', __exports__)) {
    api.reload('f44ab6ca', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=f44ab6ca", () => {
    api.rerender('f44ab6ca', render)
  })

}


export default __exports__